import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { useEffect, useState } from 'react';
import axios from 'axios';

interface IProps {
  data: any;
  isView: boolean;
  handleChangeRow: (e: any, index: number) => void;
  handelDeleteRows: (rowIdx: number) => void;
  handleChangeHead: (e: any) => void;
  openModal: any;
  removePart: any;
  handleModalForLocation: any;
}

const TController = ({
  data,
  isView,
  handleChangeHead,
  handleChangeRow,
  handelDeleteRows,
  openModal,
  removePart,
  handleModalForLocation,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            isView,
            handleChangeHead,
          }}
          head={data.head}
        />
        <TBody
          {...{
            data,
            isView,
            handleChangeRow,
            handelDeleteRows,
            openModal,
            removePart,
            handleModalForLocation,
          }}
        />
        {/* <TFoot {...{ moduleData, isView }} /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
